module.exports = __webpack_public_path__ + "static/media/skin_to_skin.f0eb34dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/skin_to_skin.png
// module id = 1480
// module chunks = 31